import React from "react";
import { number, string, func } from "prop-types";
import { SvgIconHandler } from "../../../../../atoms/svg-icon-hadler";
import "./slider-arrow.m.css";

export const SliderArrow = ({ selectedIndex, previousClick, nextClick, noOfItems, perView, languageDirection }) => {
  if (noOfItems < 1) {
    return null;
  }
  const greyStyle = { stroke: "#9FADB5", color: "#fff", opacity: "0.5" };
  return (
    <>
      <button onClick={previousClick} styleName={`${selectedIndex === 0 ? "grey-left-arrow" : "left-arrow"}`}>
        <SvgIconHandler
          type="slider-left-arrow"
          width="40px"
          height="40px"
          viewBox="0 0 40 40"
          iconStyle={selectedIndex === 0 && greyStyle}
        />
      </button>
      <button onClick={nextClick} styleName={`${selectedIndex ===  noOfItems - 1 ? "grey-right-arrow" : "right-arrow"}`}>
        <SvgIconHandler
          type="slider-right-arrow"
          width="40px"
          height="40px"
          viewBox="0 0 40 40"
          iconStyle={selectedIndex === noOfItems - 1 && greyStyle}
        />
      </button>
    </>
  );
};

SliderArrow.propTypes = {
  noOfItems: number,
  perView: number,
  slideIndicator: string,
  previousClick: func,
  nextClick: func,
  selectedIndex: number,
  languageDirection: string,
};
